import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectNewsLettersListItems } from "../../../../../../redux/news-letters/selector";
import { newsletters } from "../../../../../../redux/news-letters/action";

const ManagementNewsLetters = () => {
	const dispatch = useAppDispatch()

  const navigate = useNavigate()

  const [pageData, setPageData] = useState(1)
    const newsLetterItems = useSelector(selectNewsLettersListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Title', headerName: 'Title'},
      { field: 'Caption', headerName: 'Caption' },
      { field: 'NewsItemShowStartDateUtc', headerName: 'StartDate /Time', isDateValueFormat:true},
      { field: 'NewsItemShowEndDateUtc', headerName: 'EndDate /Time', isDateValueFormat:true},
      { field: 'MetaKeywords', headerName: 'MetaKeywords' },
      { field: 'MetaDescription', headerName: 'MetaDescription' },
      { field: 'MetaTitle', headerName: 'MetaTitle' },
      { field: 'CreatedDateUTC', headerName: 'CreatedDate /Time' , isDateValueFormat:true},
      { field: 'ModifiedDateUTC', headerName: 'ModifiedDate /Time' , isDateValueFormat:true},
      { field: 'IsCommentsAllowed', headerName: 'IsCommentsAllowed', cellRenderer: 'yesNoRenderer' },
      { field: 'Published', headerName: 'Published', cellRenderer: 'yesNoRenderer' },
      { field: 'IsLimitedToStores', headerName: 'IsLimitedToStores', cellRenderer: 'yesNoRenderer' }
      
        ]);
      }
    
  const fetchNewsLetter=()=>{
    dispatch(newsletters.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/news-letter/news-letters/list`,entity:'newsletters',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": 10,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
  }
  const handleEdit=(data: any)=>{
    navigate(`${data?.Id}`)
  }
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const additionButtons: any = [
    {
      name: 'Add NewsLetters',
      callback: () => handleAdd(),
    }
  ];
useEffect(() => {
    createColumnDefs()
    fetchNewsLetter()
}, [pageData])
const handleDelete=(data: any)=>{
dispatch(newsletters.delete({
  url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/news-letter/news-letters/delete`,
  entity: 'newsletters',
  jsonData: {
    Records: [
      {
     
            Id: data?.Id
        }
      
    ]
  }
})).then(() => {
  dispatch(newsletters.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/news-letter/news-letters/list`,entity:'newsletters',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": 10,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
});
}
return (
<>
{newsLetterItems?.isLoading ?  <PageLoader />: 
<Table columnData={columnDefs} rowData={newsLetterItems?.result?.items} setPageData={setPageData}
paginationData={newsLetterItems?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete}headingName="News Letter"/>
 
}
</> 
);
};

export default ManagementNewsLetters;


